import React, { useContext, useEffect, useState } from 'react'
import { getAdvKeyImagesAPI, updateAdvKeyImagesAPI } from '../../../../service/StudyViewerService';
import ATextField from '../../../../components/ATextField';
import { useTranslation } from 'react-i18next';
import { Modal, Spinner, SpinnerSize } from '@fluentui/react';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import studyReportContext from '../../../../context/studyreport/StudyReportContext';
import AdvKeyImageRow from './AdvKeyImageRow';
import userContext from '../../../../context/users/UserContext';
import { USERTYPES } from '../../../../constants/Constants';
import { isMobile } from 'react-device-detect';

const AdvKeyImagesModal = (props) => {

    const [advKeyImagesData, setAdvKeyImagesData] = useState([]);
    const [loading, setLoading] = useState(false);

    const {
        setAlertSuccessModal,
        alertSuccessModal
      } = useContext(studyReportContext);

    const { roles } =  useContext(userContext);

    useEffect(()=>{
        console.log("studyid of adv key images------",props.studyId);
        getAdvKeyImages(props.studyId);
    },[]);

    const getAdvKeyImages = async(studyId) =>{
      setLoading(true);
      try{
        let response = await getAdvKeyImagesAPI(studyId);
        console.log("response of adv key images", response);
          setAdvKeyImagesData(response.data.data);
          setLoading(false);
        }catch(e){
          setLoading(false);
          props.setShowManageAdvKeyImagesModal(false);
          setAlertSuccessModal(() => {
            const newItem = { ...alertSuccessModal };
            newItem.show = true;
            newItem.heading = "Alert";
            newItem.isError = true;
            newItem.isSuccess = false;
            newItem.isWarning = true;
            newItem.description = "Error while fetching key images";
            return newItem;
          });
        }
    }

    const Containerstyles=  {
        root:{
          backgroundColor: 'rgb(22, 21, 20, 0.7)'
       },
        main:{
          boxSizing: "border-box",
          borderRadius: "10px 10px 10px 10px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
          border: "1px solid #4B4B4B",
        },
    }
    
    const { t } = useTranslation();

    const updateAdvKeyImageData = async() =>{
        console.log("payload list for save---", advKeyImagesData);
        try{
            let response = await updateAdvKeyImagesAPI(props.studyId, advKeyImagesData);
            console.log(response);
            props.setShowManageAdvKeyImagesModal(false);
            if(response.data.result == "FAILURE"){
              setAlertSuccessModal(() => {
                const newItem = { ...alertSuccessModal };
                newItem.show = true;
                newItem.heading = "Alert";
                newItem.isError = true;
                newItem.isSuccess = false;
                newItem.isWarning = true;
                newItem.description = response.data.message;
                return newItem;
              });
            }
        }catch(e){
            console.log("Error while saving key images on advance viewer.");
            props.setShowManageAdvKeyImagesModal(false);
            setAlertSuccessModal(() => {
                const newItem = { ...alertSuccessModal };
                newItem.show = true;
                newItem.heading = "Alert";
                newItem.isError = true;
                newItem.isSuccess = false;
                newItem.isWarning = true;
                newItem.description = "Error while saving key images on advance viewer.";
                return newItem;
              });
        }
    }

    return (
        <>
        <Modal
          isOpen={props.showManageAdvKeyImagesModal}
          titleAriaId="id"
          scrollableContentClassName={"stop-scroll-for-modal"}
          styles={Containerstyles}
        >
          {/* NEW: fixed 500px overflows a phone screen (shifts the modal, cuts the header,
              forces horizontal scroll). Constrain to the viewport width on mobile. */}
          <div style={{ width: isMobile ? "92vw" : "500px", maxWidth: "500px" }}>
            <ModalHeader
              handleCancel={() => props.setShowManageAdvKeyImagesModal(false)}
              updatedModal = {true}
              heading = "Manage Key Images"
            />
            {loading ? (
              <div
                style={{
                  padding: "auto",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  margin:"20px"
                }}
              >
                <Spinner size={SpinnerSize.large} />
                </div>
              ) :
            <div className='modal-scroll' style={{ margin: "15px 0",maxHeight: "300px",overflowY: "auto" }}>
              {advKeyImagesData.length > 0 ? (
                <>
                  <div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          {advKeyImagesData?.map((keyImage,index) => {
                            return (
                                <React.Fragment key={index}>
                                    <AdvKeyImageRow
                                    keyImage={keyImage}
                                    setAdvKeyImagesData={setAdvKeyImagesData}
                                    advKeyImagesData={advKeyImagesData}
                                    studyId={props.studyId}
                                    index={index}
                                    roles={roles}
                                    />
                                </React.Fragment>
                            );
                          })}
                        </div>
                  </div>
                </>
              ) : (
                <>
                  <div
                    style={{
                      height: "70px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <span style={{ marginLeft: "20px", color: "#eb1b1b" }}>
                      {" "}
                      {t("key-image.no-key-images")}
                    </span>
                  </div>
                </>
              )}
            </div>
            }
            {advKeyImagesData.length > 0 && roles.length > 0 && (roles[0].includes(USERTYPES.SUPERVISOR) || roles[0].includes(USERTYPES.RADIOLOGIST) || roles[0].includes(USERTYPES.FIRMADMIN)) ?
            <ModalFooter
                PrimaryButtonList = {[
                    {
                        title:t("button.save"),
                        onclick: updateAdvKeyImageData,
                    }
                ]}
                DefaultButtonList={[
                    {
                    title: t("key-image.cancel"),
                    onclick: () => props.setShowManageAdvKeyImagesModal(false),
                    },
                ]}
            /> :
            <ModalFooter
                DefaultButtonList={[
                    {
                    title: t("key-image.cancel"),
                    onclick: () => props.setShowManageAdvKeyImagesModal(false),
                    },
                ]}
            />
            }
          </div>
        </Modal>
        </>
      );
}

export default AdvKeyImagesModal